import { NavLink } from "react-router-dom"
import {
	Button,
	FormControl,
	FormLabel,
	Link,
	RadioGroup,
	Radio,
	Stack,
	Text,
	VStack,
} from "@chakra-ui/react"
import { useEffect, useState } from "react"

export const RegistrationFirstStep = ({
	formData,
	nextStep,
	handleChange,
	id,
	partner,
}) => {
	// Local state to track selection (helps ensure we have a controlled component)
	const [localSelection, setLocalSelection] = useState(formData.selection || "")

	// Define options based on partner with unique selection values
	const userTypeOptions =
		partner === "BDPS"
			? [
					{
						name: "Real Estate Agent / Broker",
						value: "real_estate_agent",
						category: "agent",
					},
					{
						name: "Transaction Coordinator",
						value: "transaction_coordinator",
						category: "agent",
					},
					{
						name: "Property Manager",
						value: "property_manager",
						category: "agent",
					},
					{
						name: "Mortgage Lender / Servicer",
						value: "mortgage_lender",
						category: "agent",
					},
					{
						name: "Skilled Vendor",
						value: "skilled_vendor",
						category: "vendor",
					},
					{ name: "Homeowner", value: "homeowner", category: "client" },
			  ]
			: [
					{
						name: "Agent / Transaction Coordinator",
						value: "agent",
						category: "agent",
					},
					{ name: "Skilled Vendor", value: "vendor", category: "vendor" },
					{ name: "Homeowner", value: "client", category: "client" },
			  ]

	// Handle the selection change - updates selection, userType and userTypeName
	const handleUserTypeChange = (selectedValue) => {
		setLocalSelection(selectedValue)

		// Find the selected option to get its name and category
		const selectedOption = userTypeOptions.find(
			(option) => option.value === selectedValue
		)

		if (selectedOption) {
			// Directly set values in parent component
			handleChange("selection", selectedOption.value)

			// IMPORTANT: Set userType directly with the category value
			setTimeout(() => {
				// Using direct property assignment to ensure userType gets set
				if (formData) {
					formData.userType = selectedOption.category

					// Also update via the handleChange function
					handleChange("userType", selectedOption.category)
					handleChange("userTypeName", selectedOption.name)
				}
			}, 0)
		}
	}

	// Initialize or sync state when component mounts
	useEffect(() => {
		// If we have a userTypeName but no userType, find the matching option and set userType
		if (formData.userTypeName && !formData.userType) {
			const matchingOption = userTypeOptions.find(
				(option) => option.name === formData.userTypeName
			)

			if (matchingOption) {
				formData.userType = matchingOption.category // Direct assignment
				handleChange("userType", matchingOption.category) // Also update via function
			}
		}

		// If we have a selection but no userType, find the matching option and set userType
		if (formData.selection && !formData.userType) {
			const matchingOption = userTypeOptions.find(
				(option) => option.value === formData.selection
			)

			if (matchingOption) {
				formData.userType = matchingOption.category // Direct assignment
				handleChange("userType", matchingOption.category) // Also update via function
			}
		}
	}, [])

	return (
		<FormControl>
			<VStack gap={2} alignItems="left">
				<FormControl>
					<FormLabel>What best describes you?</FormLabel>
					<RadioGroup
						value={localSelection}
						onChange={handleUserTypeChange}
						mb="30px"
					>
						<Stack direction="column">
							{userTypeOptions.map((option, index) => (
								<Radio key={index} value={option.value}>
									<Text>{option.name}</Text>
								</Radio>
							))}
						</Stack>
					</RadioGroup>
				</FormControl>
				{formData.userType === "client" && !id && (
					<Text color="blue.700">
						Contact your real estate agent to send you an invite to{" "}
						{partner ? "Black Dome Services" : "Quiplo"}.
					</Text>
				)}
				<Button
					w="100%"
					bgColor={partner === "BDPS" ? "#25d366" : "borderColor"}
					color="white"
					onClick={nextStep}
					isDisabled={formData.userType === "client" && !id}
				>
					Continue
				</Button>
				<Text fontSize="15px">
					Already have an account?{" "}
					<Link as={NavLink} to={"/login"}>
						Login
					</Link>
				</Text>
			</VStack>
		</FormControl>
	)
}
